import { cn } from '@/lib/utils'
import {
  Globe,
  Activity,
  Users,
  Settings,
  Server,
  Wrench,
  Signal,
  Shield,
  Search,
} from 'lucide-react'

export type SiteTab = 'overview' | 'activity' | 'users' | 'settings' | 'diagnostics' | 'uptime' | 'geo-blocking' | 'seo-health' | 'manage'

interface TabItem {
  id: SiteTab
  label: string
  icon: typeof Globe
}

const tabs: TabItem[] = [
  { id: 'overview', label: 'Overview', icon: Globe },
  { id: 'activity', label: 'Activity', icon: Activity },
  { id: 'users', label: 'Users', icon: Users },
  { id: 'settings', label: 'Settings', icon: Settings },
  { id: 'diagnostics', label: 'Diagnostics', icon: Server },
  { id: 'uptime', label: 'Uptime', icon: Signal },
  { id: 'seo-health', label: 'SEO Health', icon: Search },
  { id: 'geo-blocking', label: 'Geo-Blocking', icon: Shield },
  { id: 'manage', label: 'Manage', icon: Wrench },
]

interface SiteDetailSidebarProps {
  activeTab: SiteTab
  onTabChange: (tab: SiteTab) => void
}

export function SiteDetailSidebar({ activeTab, onTabChange }: SiteDetailSidebarProps) {
  return (
    <nav className="flex md:w-48 md:shrink-0 md:flex-col gap-1 md:border-r md:p-4 border-b md:border-b-0 px-4 py-2 md:px-4 overflow-x-auto md:overflow-x-visible">
      {tabs.map((tab) => {
        const Icon = tab.icon
        const isActive = activeTab === tab.id
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'flex items-center gap-2 md:gap-3 rounded-lg px-3 py-2 text-sm font-medium whitespace-nowrap md:whitespace-normal transition-colors',
              isActive
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            )}
          >
            <Icon className="h-4 w-4" />
            {tab.label}
          </button>
        )
      })}
    </nav>
  )
}
